import React from "react";
import { connect } from 'react-redux';
import _ from 'lodash';
import { format, getDay, addDays, setMinutes, setSeconds, startOfWeek, setMilliseconds, parse } from 'date-fns'
import { Actions as ACTIONS } from '../../../store/actions/leaveActions';
import BenefitType from "./BenefitType";
import { validateFloat } from "../../common/validation/Validators";

const BreakdownDay = ({
    weekStartsOn,
    modalLeave,
    modalStatus,
    currentAgreement,
    day,
    weekNo,
    updateBreakdown,
    holidays,
    addPhToLeave,
    blockType
}) => {
    const today = setMinutes(setSeconds(setMilliseconds(new Date(), 0), 0), 0);
    const { date, dateTo, hoursBreakdown, type } = modalLeave
    const { daysNotWorked, isShiftWorker } = currentAgreement
    const { lastPaidDate } = modalStatus

    if (blockType === 'week') return (
        <div style={{ height: '2.5rem', width: '2.5rem', margin: 'auto', background: '#eceff1', paddingTop: '0.5rem', position: 'relative' }}>
            {weekNo + 1}
            <BenefitType day={day} weekNo={weekNo} blockType={blockType} />
        </div>
    )

    // console.debug(day)
    const fromDate = date && parse(date, 'yyyy-MM-dd', new Date()) || today
    const toDate = dateTo && parse(dateTo, 'yyyy-MM-dd', new Date()) || today
    const firstDay = startOfWeek(fromDate, { weekStartsOn })
    const dayInPeriod = day + weekNo * 7
    const dateToUse = addDays(firstDay, dayInPeriod)
    const dateToUseString = format(dateToUse, "yyyy-MM-dd")
    const isInPaidRange = parse(lastPaidDate, 'yyyy-MM-dd', new Date()) >= dateToUse
    const outOfRange = dateToUse < fromDate || toDate < dateToUse
    const isDayNotWorked = daysNotWorked?.includes(getDay(dateToUse))
    const isPaid = hoursBreakdown?.[dateToUseString]?.isPaid
    const sickType = hoursBreakdown?.[dateToUseString]?.sickType
    const editedSickType = hoursBreakdown?.[dateToUseString]?.editedSickType
    const isHoliday = ((editedSickType ? editedSickType : sickType) != 'US' && ['6020', '6022'].includes(String(type)) && holidays?.includes(dateToUseString)) && !addPhToLeave && !isShiftWorker
    const disabled = (outOfRange  || isInPaidRange || isDayNotWorked || isHoliday) && !hoursBreakdown?.[dateToUseString]?.hours

    return (
        <td key={day} style={{ position: 'relative', height: 35 }}>
            {/* <Tooltip content={isDayNotWorked && `Employee does not work on this day`}> */}

            <input
                style={{
                    border: isPaid || disabled ? "solid 1px #eceff1" : "solid 1px #ea611c",
                    cursor: isPaid || disabled ? "not-allowed" : 'auto',
                    width: "30px",
                    textAlign: "center",
                    background: isPaid || disabled ? "#eceff1" : 'inherit',
                }}
                value={hoursBreakdown?.[dateToUseString]?.hours || ''}
                disabled={isPaid || disabled}
                onChange={(e) => {
                    if (validateFloat(e.target.value) > 24) return
                    updateBreakdown({ dateToUseString, hours: validateFloat(e.target.value) })
                }}
            />
            <BenefitType day={day} weekNo={weekNo} />
            {/* </Tooltip> */}

        </td>
    )
}

const mapStateToProps = (state) => {
    return {
        jurisdiction: state.company?.settings?.jurisdiction,
        weekStartsOn: state.company?.settings?.jurisdiction == "UK" ? 0 : 1,
        modalLeave: state.leave.modalLeave || {},
        modalStatus: state.leave?.modalStatus?.status || {},
        holidays: state.leave?.modalStatus?.holidays,
        addPhToLeave: !!state.leave?.leaveSettings?.addPhToLeave,
        currentAgreement: state?.leave?.modalStatus?.employee || {},
        days: state.leave?.days
    }
}

const mapDispatchToProps = dispatch => ({
    updateBreakdown: ({ dateToUseString, hours }) => {
        dispatch(ACTIONS.updateBreakdown({ dateToUseString, hours, edited: true }))
        dispatch(ACTIONS.mapBreakdown())
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BreakdownDay)
